import config from '../config';
import selectedEnvironment from '../env';

const API_BASE = `${config[selectedEnvironment].API_URL}/ClientTaxAdvanceYearly`;

const authHeaders = (token, json = false) => ({
    Authorization: `Bearer ${token}`,
    ...(json ? { 'Content-Type': 'application/json' } : {}),
});

const getByCaseId = async (token, caseId) => {
    const response = await fetch(`${API_BASE}/${encodeURIComponent(caseId)}`, {
        method: 'GET',
        headers: authHeaders(token),
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
};

const upsert = async (token, payload) => {
    const response = await fetch(`${API_BASE}`, {
        method: 'PUT',
        headers: authHeaders(token, true),
        body: JSON.stringify(payload),
    });
    if (!response.ok) {
        const text = await response.text();
        throw new Error(text || `HTTP error! status: ${response.status}`);
    }
    return response.json();
};

const remove = async (token, id, caseId) => {
    const response = await fetch(
        `${API_BASE}/${encodeURIComponent(id)}?caseId=${encodeURIComponent(caseId)}`,
        {
            method: 'DELETE',
            headers: authHeaders(token),
        }
    );
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
};

const clientTaxAdvanceYearlyService = {
    getByCaseId,
    upsert,
    remove,
};

export default clientTaxAdvanceYearlyService;
